<div dragScroll
     class="center">
    @for (item of component.quick_links; let last = $last; track item.url) {
    @switch(component.quick_link_type) {
    @case('image') {
    <href class="_quick-link m-l-2 m-r-2 yes-wrap _user-drag-none"
          draggable="false"
          [link]="item.url">
        <div class="flex flex-column flex-middle"
             [ngClass]="!last ? component.quick_link_margin : ''">
            <div class="ratio-1-1 _image">
                <img draggable="false"
                     class="rf _user-drag-none"
                     [image]="item.image">
            </div>
            <h5 class="td-underline center _text m-t-10 m-t-4-s p-a-0 break-words"
                [ngClass]="[component.text_color || '', component.text_font_style || '']"
                *iCms="'text' of item; skipEmpty: true"></h5>
        </div>
    </href>
    }
    @case('link') {
    <href class="b-a b-col-42 cursor-pointer inline-block yes-wrap"
          [ngClass]="!last ? component.quick_link_margin : ''"
          [link]="item.url"
          [hrefClass]="'_user-drag-none'">
        <h4 class="h4 m-a-2 no-wrap"
            [ngClass]="[component.text_color || '', component.text_font_style || '']"
            *iCms="'text' of item; skipEmpty: true"></h4>
    </href>
    }
    }
    }
</div>